// extracted by mini-css-extract-plugin
export default {"menuItemContainer":"menu-item_menuItemContainer__vGIVD","activeClass":"menu-item_activeClass__iW23n"};